import React from "react";
import "./BanksModal.scss";
import ReactModal from "react-modal";
import Select from "react-select";
import { addAppBank } from "../../api/index";
import Loader from "../loader/loader";
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid #EAEBEF",
        padding: 10,
        fontSize: 14,
        color: "#58585B",
    }),
    control: () => ({
        width: "100%",
    }),
};
class BanksModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            menuCLose: true,
            show_spinner: false,
        };
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
    };

    addBank() {
        if (this.state.selectedOption != null) {
            let data = {};
            data.id = this.props.appId;
            data.bank_id = this.state.selectedOption.value;
            data.child_app = this.props.childApp;
            this.setState({ show_spinner: true });
            addAppBank(data)
                .then((response) => {
                    if (response.status) {
                        this.setState({
                            selectedOption: null,
                            show_spinner: false,
                        });
                        this.props.bankChange();
                    } else {
                        this.setState({
                            selectedOption: null,
                            show_spinner: false,
                        });
                        this.props.handleClose();
                    }
                })
                .catch((error) => console.log(error));
        } else {
            this.setState({ selectedOption: null, show_spinner: false });
            this.props.handleClose();
        }
    }

    render() {
        const { selectedOption, show_spinner } = this.state;
        return (
            <ReactModal isOpen={this.props.show} className="banks-modal">
                <div className="modal-header">
                    <h4 className="text-left">Assign MSP</h4>
                </div>
                <div className="modal-body">
                    <p>
                        Select the appropriate msp for the app ID{" "}
                        {this.props.appId}
                    </p>
                    <Select
                        styles={customStyles}
                        className={
                            this.state.menuCLose
                                ? "custom-slect bannkmodalselect"
                                : "active-slect"
                        }
                        options={this.props.banks}
                        onChange={this.handleChange}
                        value={selectedOption}
                        placeholder="Select MSP"
                        onMenuClose={(e) => this.setState({ menuCLose: true })}
                        onMenuOpen={(e) => this.setState({ menuCLose: false })}
                    />
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <div className="modal-footer">
                    <button
                        className="btn cancel-button"
                        onClick={this.props.handleClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn confirm-button"
                        onClick={(e) => this.addBank()}
                    >
                        Assign
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default BanksModal;
